import React from "react";
import { LegalDocumentModal } from "@/shared/legal/LegalDocumentModal";
import {
	BRAND_AGENCY_PRIVACY_NOTICE_META,
	BrandAgencyPrivacyNoticeDocument,
} from "@/shared/legal/BrandAgencyPrivacyNoticeDocument";

interface BrandAgencyPrivacyNoticeModalProps {
	open: boolean;
	onClose: () => void;
}

export const BrandAgencyPrivacyNoticeModal: React.FC<BrandAgencyPrivacyNoticeModalProps> = ({ open, onClose }) => (
	<LegalDocumentModal open={open} onClose={onClose} meta={BRAND_AGENCY_PRIVACY_NOTICE_META}>
		<BrandAgencyPrivacyNoticeDocument />
	</LegalDocumentModal>
);
